import script from "./edit-project.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-project.vue?vue&type=script&setup=true&lang=js"

import "./edit-project.vue?vue&type=style&index=0&id=1c59d5cf&lang=css"

const __exports__ = script;

export default __exports__